<template>
  <button @click="handleScroll">
    <slot />
  </button>
</template>

<script>
export default {
  methods: {
    handleScroll() {
      const resultsPosition = document.getElementById('results').getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({
        top: resultsPosition - 85,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/BaseScrollButton.vue